"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get TeamsGraphNotificationItem () {
        return TeamsGraphNotificationItem;
    },
    get TeamsGraphWebhookPayload () {
        return TeamsGraphWebhookPayload;
    },
    get TeamsGraphWebhookReceivedResponse () {
        return TeamsGraphWebhookReceivedResponse;
    }
});
const _zod = require("zod");
const TeamsGraphNotificationItem = _zod.z.object({
    subscriptionId: _zod.z.string(),
    clientState: _zod.z.string().optional(),
    changeType: _zod.z.string().optional(),
    resource: _zod.z.string().optional(),
    resourceData: _zod.z.object({}).passthrough().optional(),
    lifecycleEvent: _zod.z.string().optional()
}).passthrough();
const TeamsGraphWebhookPayload = _zod.z.object({
    value: _zod.z.array(TeamsGraphNotificationItem)
}).passthrough();
const TeamsGraphWebhookReceivedResponse = _zod.z.object({
    received: _zod.z.boolean()
});
